import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {FreePlayContainerComponent} from "../../free-play/free-play-container.component";


export class MiniOrbitFreePlayDetails extends OrbitComponent<{}> {
  render(): React.ReactNode {
    return (
      <FreePlayContainerComponent/>
    );
  }
}
